import React from 'react';
import { View } from 'react-native';

import { Typography } from '@components/Typography';
import { makeStyles } from '@providers/Theme';

type AddressPartProps = {
  label: React.ReactNode;
  value: React.ReactNode;
};

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
    on: {
      sm: {
        minWidth: '25%',
      },
    },
  },
}));

export const AddressPart: React.FC<AddressPartProps> = ({ label, value }) => {
  const styles = useStyles();

  return (
    <View style={styles.root}>
      <Typography weight="bold">{label}:&nbsp;</Typography>
      <Typography weight="bold">{value}</Typography>
    </View>
  );
};
